import { SkeletonBody as AntdSkeletonBody } from "@empglabs/backoffice-ui-kit"

const SkeletonBody = props => {
  return <AntdSkeletonBody {...props} />
}

export default SkeletonBody
